(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('OrderSelfController', OrderSelfController);

    OrderSelfController.$inject = ['$scope', 'Principal', 'LoginService', '$state','User','MessageService', 'ParseLinks', 'SalesOrder',
    '$uibModal', 'Supplier','Product', '$localStorage','$http', '$stateParams', '$rootScope', '$location', 'ProductCategory','OrderPack'];

    function OrderSelfController ($scope, Principal, LoginService, $state,User,MessageService, ParseLinks, SalesOrder,
        $uibModal, Supplier, Product, $localStorage, $http, $stateParams, $rootScope, $location, ProductCategory,OrderPack) {
        var vm = this;

        // 判断是否具有当前页面的访问权限
        Principal.hasAuthority('ROLE_SELF_SUPPORT_ORDER').then(function (data) {
            if (!data) {
                MessageService.error("不好意思，你不具有订单访问的权限！");
                $state.go("home");
            }
        });
        vm.token = $localStorage.authenticationToken;
        vm.selectedList = []
        vm.pageSize = [
            {name:'10', value:10},
            {name:'15', value: 15},
            {name:'20', value: 20},
            {name:'30', value: 30},
            {name:'40', value: 40},
            {name:'50', value: 50}
        ];
        vm.stateList = [
            {name:'待分配', value:'ToBeAssigned'},
            {name:'已分配', value: 'Assigned'},
            {name:'生产中', value: 'Producing'},
            {name:'已发货', value: 'Delivered'}
        ];
        vm.sourceList = [
            {name:'自营订单', value:'self'},
            {name:'第三方平台', value: '第三方平台'},
            {name:'外接订单', value: '外接订单'}
        ];
        vm.backList = [
            {name:'已回件', value: "true"},
            {name:'未回件', value: "false"}
        ];
        vm.replenishmentList = [
            {name:'是', value: "true"},
            {name:'否', value: "false"}
        ];
        vm.refundList = [
            {name:'是', value: "true"},
            {name:'否', value: "false"}
        ];
        vm.conditionList = [
            {name:'全部', value:''},
            {name:'处理中', value:'FileProcessing'},
            {name:'待分配', value:'ToBeAssigned'},
            {name:'已分配', value: 'Assigned'},
            {name:'生产中', value: 'Producing'},
            {name:'已回件', value: 'Collect'},
            {name:'已发货', value: 'Delivered'},
            {name:'已揽件', value: 'Receiving'},
            {name:'已签收', value: 'Received'},
            {name:'物流异常', value: 'Abnormal'},
            {name:'已撤回', value: 'Deleted'}
        ];
        vm.deliveryMethodList = [
            {name:'自提', value: "Self"},
            {name:'快递', value: "Delivery"}
        ];
        //商品品类 一级
        vm.promoteProducts = ProductCategory.getAllCategory();
        vm.productCategoryId = "";
        vm.productCategorySecondId = "";

        vm.predicate = 'createdDate';
        vm.resolve = false;
        vm.page = $stateParams.page || $location.search().page;
        vm.tableData = {
            sort: [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')],
            page: Number(vm.page) || 0,
            size: 20,
            keyword: $stateParams.keyword || $location.search().keyword || '',
            state:$stateParams.state || $location.search().state || '',
            source:$stateParams.source || $location.search().source || '',
            startDate: $stateParams.startDate || $location.search().startDate || null,
            endDate: $stateParams.endDate || $location.search().endDate || GetDateStr(0),
            back: $stateParams.back || $location.search().back || '',
            timeWarning: $stateParams.timeWarning || $location.search().timeWarning || '',
            replenishment: $stateParams.replenishment || $location.search().replenishment || '',
            refund: $stateParams.refund || $location.search().refund || '',
            supplierId: $stateParams.supplierId || $location.search().supplierId || '',
            productId: $stateParams.productId || $location.search().productId ||'',
            productCategoryId: '',
            sku:$stateParams.sku || $location.search().sku ||'',
            orderType: 'Ordering',
            phone: $stateParams.phone || $location.search().phone || '',
            logisticsNumber: $stateParams.logisticsNumber || $location.search().logisticsNumber || '',
            deliveryType: $stateParams.deliveryType || $location.search().deliveryType || '',
            storeName: $stateParams.storeName || $location.search().storeName || '',
        };
        angular.element("#startDate").val($stateParams.startDate || $location.search().startDate || null);
        angular.element("#endDate").val($stateParams.endDate || $location.search().endDate || null);
        vm.isFilter = vm.tableData.back || vm.tableData.replenishment || vm.tableData.refund ? true : false;
        Supplier.getAll("", function (res) {
            vm.suppliers = res;
            if(vm.tableData.supplierId != ''){
                for(var i=0; i<vm.suppliers.length; i++ ){
                    if(vm.suppliers[i].id == vm.tableData.supplierId){
                        vm.supplier = vm.suppliers[i];
                    }
                }
            }
        });
        Product.getAllByCategory({type: 'OrderingProduct'}, function (res) {
            vm.productList = res;
            if(vm.tableData.productId != ''){
                for(var i=0; i<vm.productList.length; i++ ){
                    if(vm.productList[i].id == vm.tableData.productId){
                        vm.product = vm.productList[i];
                        vm.skuList = vm.productList[i].propertyConfigs;
                    }
                }
            }
        });

        //获取选中的数组
        $scope.checked =[];
        $scope.tableTr = function(data){
            var index = $scope.checked.indexOf(data);
            if(index == -1 && data.checked){
                $scope.checked.push(data);
            }else if (!data.checked && index !== -1){
                $scope.checked.splice(index, 1);
            }
            if (vm.salesOrders.length === $scope.checked.length) {
                $scope.select_all = true;
            } else {
                $scope.select_all = false;
            }
            vm.selectedList = $scope.checked
            vm.tablePitch = $scope.checked.length >0 ?true:false;
        };

        // 计算订单份数
        vm.calculateTotalQuantity = function() {
            var total = 0;
            if (vm.selectedList && vm.selectedList.length > 0) {
                angular.forEach(vm.selectedList, function(item) {
                    total += parseInt(item.quantity) || 0;
                });
            }
            return total;
        };

        // 获取当前时间，格式为YYYY/MM/DD HH:MM:SS
        vm.getCurrentTime = function() {
            var now = new Date();
            var year = now.getFullYear();
            var month = (now.getMonth() + 1).toString().padStart(2, '0');
            var day = now.getDate().toString().padStart(2, '0');
            var hours = now.getHours().toString().padStart(2, '0');
            var minutes = now.getMinutes().toString().padStart(2, '0');
            var seconds = now.getSeconds().toString().padStart(2, '0');
            return year + '/' + month + '/' + day + ' ' + hours + ':' + minutes + ':' + seconds;
        };

        $scope.selectAll = function(){
            if($scope.select_all) {
                angular.forEach(vm.salesOrders, function (item) {
                    item.checked = true;
                });
                $scope.checked = vm.salesOrders.map(function(value){
                    return value;
                })
            }else {
                angular.forEach(vm.salesOrders, function (item) {
                    item.checked = false;
                });
                $scope.checked = [];
            }
            vm.selectedList = $scope.checked
            vm.tablePitch = $scope.checked.length >0 ?true:false;
        };


        init();
        function init() {
            vm.tablePitch = '';
            $scope.select_all = false;
            $scope.checked =[];
            vm.tableData.startDate = angular.copy(angular.element("#startDate").val());
            vm.tableData.endDate = angular.copy(angular.element("#endDate").val());

            $location.search({
                'page':vm.tableData.page,
                'state':vm.tableData.state,
                'source':vm.tableData.source,
                'startDate':vm.tableData.startDate,
                'endDate':vm.tableData.endDate,
                'back':vm.tableData.back,
                'timeWarning':vm.tableData.timeWarning,
                'replenishment':vm.tableData.replenishment,
                'refund':vm.tableData.refund,
                'supplierId':vm.tableData.supplierId,
                'productId':vm.tableData.productId,
                'keyword':vm.tableData.keyword,
                'productCategoryId':vm.tableData.productCategoryId,
                'sku':vm.tableData.sku,
                'phone':vm.tableData.phone,
                'logisticsNumber':vm.tableData.logisticsNumber,
                'deliveryType':vm.tableData.deliveryType,
                'storeName':vm.tableData.storeName,
            });
            SalesOrder.query(vm.tableData, function(res, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.queryCount = headers('X-Total-Count');
                vm.salesOrders = res;
                var pages = Math.ceil(vm.queryCount/vm.tableData.size); //得到总页数
                vm.pagecount = pages; //得到总页数
                //调用分页
                laypage({
                    cont: 'paging',
                    curr: (vm.tableData.page + 1), //初始化当前页
                    pages: pages,
                    skip: true, //是否开启跳页
                    first: false,
                    last: false,
                    limit: true,
                    jump: function(obj, first){
                        if (!first) {
                            vm.tableData.page = obj.curr - 1;
                            init();
                        }
                    }
                });
            }, function (error) {

            });

            //获取订单总数和总张数
            $scope.orderNumberTotal = 0;
            $scope.pageCountTotal = 0;
            SalesOrder.getNumByCondition(vm.tableData, function(res) {
                $scope.orderNumberTotal = res.total;
                $scope.pageCountTotal = res.pages == null ? 0 : res.pages;
            });
        };

        $scope.sort = function () {
            vm.tableData.sort = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            init();
        }

        //商品1级品类
        $scope.promoteProductsSelect = function(){
            vm.promoteProductsSecond = [];
            vm.tableData.productCategoryId = vm.productCategoryId;
            for(var i=0; i<vm.promoteProducts.length; i++){
                if(vm.promoteProducts[i].id == vm.productCategoryId){
                    // console.log(vm.promoteProducts[i]);
                    vm.promoteProductsSecond = vm.promoteProducts[i].productCategoryVMS;
                }
            }
        }
        //商品品类 二级
        $scope.promoteProductsSecondSelect = function(){
            if(!vm.productCategorySecondId){
                vm.tableData.productCategoryId = vm.productCategoryId;
            }else {
                vm.tableData.productCategoryId = vm.productCategorySecondId;
            }
        }

        $scope.selectSupplier =function(data){
            if(data){
                vm.tableData.supplierId = data.id;
            }else {
                vm.tableData.supplierId = "";
            }
        };
        $scope.selectProduct =function(data){
            if(data){
                vm.tableData.productId = data.id;
                vm.skuList = data.propertyConfigs;
            }else {
                vm.tableData.productId = "";
                vm.tableData.sku = "";
                vm.skuList = [];
            }
        };
        $scope.filter = function(){
            vm.isFilter = !vm.isFilter;
        };
        $scope.conditionSelect = function(data){
            vm.tableData.state = data.value;
            vm.tableData.timeWarning = '';
            vm.tableData.page = 0;
            init()
        };
        $scope.warningSelect = function(){
            vm.tableData.state = "";
            vm.tableData.timeWarning = 1;
            vm.tableData.page = 0;
            init()
        };
        $scope.search = function(){
            vm.tableData.page = 0;
            init();
        };

        $scope.reset = function(){
            vm.isFilter = false;
            vm.tableData = {
                sort: ['createdDate,DESC'],
                page: 0,
                size: 20,
                state:'',
                source:'',
                startDate: '',
                endDate: '',
                back: '',
                timeWarning:'',
                replenishment: '',
                refund: '',
                condition: '全部',
                supplierId: '',
                productId: '',
                productCategoryId:'',
                sku:'',
                orderType: 'Ordering'
            };
            vm.supplier = "";
            vm.product = "";
            angular.element("#startDate").val("");
            angular.element("#endDate").val("");
            init();
            localStorage.removeItem('tableData');
        };

        //查看订单
        $scope.orderLook = function () {
            if($scope.checked.length >1){
                MessageService.error('仅能查看一个订单，请选择！');
                return;
            }else{
                $state.go('orderDetails',{
                    id:$scope.checked[0].id,
                    page: vm.tableData.page,
                    state:vm.tableData.state,
                    source:vm.tableData.source,
                    startDate:vm.tableData.startDate,
                    endDate:vm.tableData.endDate,
                    back:vm.tableData.back,
                    timeWarning:vm.tableData.timeWarning,
                    replenishment:vm.tableData.replenishment,
                    refund:vm.tableData.refund,
                    supplierId:vm.tableData.supplierId,
                    productId:vm.tableData.productId,
                    keyword:vm.tableData.keyword,
                    productCategoryId:vm.tableData.productCategoryId,
                    sku:vm.tableData.sku,
                    phone:vm.tableData.phone,
                    logisticsNumber:vm.tableData.logisticsNumber,
                });
            }
        };

        //客户备注
        $scope.orderRemark = function () {
            if($scope.checked.length >1){
                MessageService.error('只能选择一个订单 ！');
                return;
            }else {
                $uibModal.open({
                    templateUrl: 'app/order/order-remark.html',
                    controller: 'OrderRemarkController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    resolve: {
                        entity: [function () {
                            return $scope.checked[0]
                        }]
                    }
                }).result.then(function (backData) {
                    // console.log(backData);
                });
            }
        };

        //补货订单
        $scope.orderReplenishment = function(){
            if($scope.checked.length >1){
                MessageService.error('只能选择一个订单！');
                return;
            }else {
                if ($scope.checked[0].status == 'ToBeAssigned' || $scope.checked[0].status == 'Assigned'
                 || $scope.checked[0].status == 'Producing' ) {
                    MessageService.error('请选择已发货的订单进行补货！');
                    return;
                }
                if (!!$scope.checked[0].replenishmentBeforeNumber) {
                    MessageService.error('请选择最初订单进行补货！');
                    return;
                } else {
                    $uibModal.open({
                    templateUrl: 'app/order/order-replenishment.html',
                    controller: 'OrderReplenishmentController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    resolve: {
                        entity: [function () {
                            return $scope.checked[0]
                        }]
                    }
                    }).result.then(function (backData) {
                        if (backData) {
                            init()
                        }
                    });
                }
            }
        };

        //撤回操作
        $scope.orderClose = function(){
            if($scope.checked.length == 0){
                MessageService.error('请选择订单！');
                return;
            }else {
                if($scope.checked.some(function(item){return item.status == 'Delivered' || item.status == 'Receiving' || item.status == 'Received' || item.status == 'Abnormal'})){
                    MessageService.error('只能撤回处理中、待分配、已分配、生产中这四个状态的订单');
                    return;
                }
                var ids = $scope.checked.map(function(item){return item.orderPackId});
                MessageService.confirm("已选中"+ids.length+"条订单，是否确认撤回订单？", function () {
                    OrderPack.revoke(ids, function(res) {
                        MessageService.success("撤回成功");
                        init()
                    }, function (error) {
                        MessageService.error(error.data.message || "撤回失败，请重试！");
                    });
                });
            }
        };

        //选择物流公司
        $scope.orderExpress = function(){

            //如果是已发货状态则不能修改物流公司
            var flagExpress =false;
            angular.forEach($scope.checked,function(item){
                if(item.status =="Delivered"){
                    flagExpress =true;
                    return;
                }
            });
            if(flagExpress){
                MessageService.error('存在已发货的订单，不能修改物流公司，请重新选择！');
                return;
            }else{
                $uibModal.open({
                    templateUrl: 'app/order/order-express.html',
                    controller: 'OrderExpressController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    resolve: {
                        entity: [function() {
                            return $scope.checked
                        }]
                    }
                }).result.then(function (backData) {
                    if(backData){
                        init()
                    }
                });
            }
        };

        //修改
        $scope.modification = function(){
            var flagExpress =false;
            var isStatus =false;
            var isStatusProducing =false;
            angular.forEach($scope.checked,function(item, index){
                if(item.status !="Assigned" && item.status !="Producing" && item.status !="Delivered"){
                    flagExpress =true;
                    return;
                }
                if(index>0 && item.status != $scope.checked[index-1].status){
                    isStatus =true;
                    return;
                }
                if(item.status == "Producing" && $scope.checked.length>1){
                    isStatusProducing =true;
                    return;
                }
            });
            if(flagExpress){
                MessageService.error('只能修改已分配、生产中、已发货这三个状态的订单');
                return;
            }
            if(isStatus){
                MessageService.error('请选择相同状态下的订单');
                return;
            }
            if(isStatusProducing){
                MessageService.error('生产中的订单只能选择一个');
                return;
            }
            $uibModal.open({
                templateUrl: 'app/order/order-modification.html',
                controller: 'OrderModificationController',
                controllerAs: 'vm',
                backdrop: 'static',
                resolve: {
                    entity: [function() {
                        return $scope.checked
                    }]
                }
            }).result.then(function (backData) {
                if(backData){
                    init()
                }
            });
        }
        $scope.handleDelivery = function(){
            $uibModal.open({
                templateUrl: 'app/order/order-modification.html',
                controller: 'OrderModificationController',
                controllerAs: 'vm',
                backdrop: 'static',
                resolve: {
                    entity: [function() {
                        return $scope.checked
                    }]
                }
            }).result.then(function (backData) {
                if(backData){
                    init()
                }
            });
        }

        //导出
        $scope.orderExport = function () {
            $http({
                url: 'api/sales_order/exportData1',
                method: "GET",
                params: vm.tableData,
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': "Bearer " + vm.token
                },
                responseType: 'blob'
            }).success(function (data, status, headers, config) {
                var blob = new Blob([data], {type: "application/vnd.ms-excel"});
                var objectUrl = URL.createObjectURL(blob);
                var a = document.createElement('a');
                document.body.appendChild(a);
                a.setAttribute('style', 'display:none');
                a.setAttribute('href', objectUrl);
                var filename = Date.now() + ".xls";
                a.setAttribute('download', '');
                a.click();
                URL.revokeObjectURL(objectUrl);
                document.body.removeChild(a);
                MessageService.success("导出成功");
            }).error(function (data, status, headers, config) {
                MessageService.error(data.data.message || "导出失败，请重试！");
            });
        };

        $rootScope.$on('$stateChangeSuccess', function (ev, to, toParams, from, fromParams) {
            $rootScope.previousState = from;
            $rootScope.previousParams = fromParams;
        });

        //日期
        function GetDateStr(AddDayCount) {
            var dd = new Date();
            dd.setDate(dd.getDate()+AddDayCount);
            var y = dd.getFullYear();
            var m = (dd.getMonth()+1) < 10 ? '0' + (dd.getMonth()+1) : dd.getMonth()+1;//获取当前月份的日期
            var d = dd.getDate() < 10 ? '0' + dd.getDate() : dd.getDate();
            return y+"-"+m+"-"+d;
        }
        $scope.handlePrint = function(){

            // 获取预览区域元素
            var previewElement = document.getElementById('previewId');

            // 保存原始样式
            var originalStyle = previewElement.style.cssText;

            // 临时显示预览区域
            previewElement.style.display = 'block';
            previewElement.style.position = 'relative';
            previewElement.style.visibility = 'visible';

            // 等待更长时间确保内容（特别是条形码）完全加载
            setTimeout(function () {

                // 为预览区域添加打印样式
                var style = document.createElement('style');
                style.type = 'text/css';
                style.innerHTML = '@media print { @page { size: landscape; } }';
                previewElement.appendChild(style);
                // 创建用于打印的iframe
                var printIframe = document.getElementById('print-frame');
                if (printIframe === null || printIframe === undefined) {
                    printIframe = document.createElement('iframe');
                    printIframe.lang = 'en';
                    printIframe.style.display = 'none';
                    printIframe.id = 'print-frame';
                    document.body.insertBefore(printIframe, document.body.children[0]);
                }
                printIframe.contentDocument.head.innerHTML = "<meta charset='UTF-8'><title></title><link rel='stylesheet' href='content/css/main.css'><link rel='stylesheet' href='bower_components/bootstrap/dist/css/bootstrap.css'>";
                printIframe.contentDocument.body.innerHTML = previewElement.innerHTML;
                printIframe.contentWindow.focus();
                printIframe.contentWindow.print();

                // 创建用于PDF生成的iframe
                var pdfIframe = document.createElement('iframe');
                pdfIframe.style.display = 'none';
                document.body.appendChild(pdfIframe);

                // 等待iframe加载完成
                pdfIframe.onload = function() {
                    // 向iframe中添加内容
                    pdfIframe.contentDocument.open();
                    pdfIframe.contentDocument.write('<!DOCTYPE html><html><head><meta charset="UTF-8"><title>PDF</title><link rel="stylesheet" href="content/css/main.css"><link rel="stylesheet" href="bower_components/bootstrap/dist/css/bootstrap.css"></head><body>');
                    pdfIframe.contentDocument.write(previewElement.innerHTML);
                    pdfIframe.contentDocument.write('</body></html>');
                    pdfIframe.contentDocument.close();

                    // 等待内容渲染
                    setTimeout(function() {
                        try {
                            // 在iframe中生成PDF
                            var opt = {
                              margin: 10,
                              filename: '订单_' + new Date().getTime() + '.pdf',
                              image: { type: 'jpeg', quality: 0.98 },
                              html2canvas: { scale: 2, useCORS: true, logging: true },
                              jsPDF: { unit: 'mm', format: 'a4', orientation: 'landscape' }
                            };

                            // 使用iframe的body作为源
                            html2pdf().set(opt).from(pdfIframe.contentDocument.body).save().then(function() {
                                // 清理
                                document.body.removeChild(pdfIframe);
                                previewElement.style.cssText = originalStyle;
                            }).catch(function(error) {
                                // 清理
                                document.body.removeChild(pdfIframe);
                                previewElement.style.cssText = originalStyle;
                            });
                        } catch (error) {
                            // 清理
                            document.body.removeChild(pdfIframe);
                            previewElement.style.cssText = originalStyle;
                        }
                    }, 1000); // 等待内容渲染
                };

                // 触发iframe加载
                pdfIframe.src = 'about:blank';
            }, 2000); // 增加延迟时间确保内容完全加载，特别是条形码
        }
    }
})();
